<template>
  <v-container fluid class="pa-4">
    <!-- Susun atur mengikut halaman Status Sambungan (db-status): SATU <v-row>
         nisbah 5/7 — KIRI = keadaan & tetapan (Status Tangkapan, Jadual Harian,
         Prestasi), KANAN = tindakan & keluaran (Mulakan Migrasi + panel log,
         Sejarah Migrasi).

         Nisbah 5/7 dan bukan 6/6 atas sebab yang sama seperti di sana: panel
         log dan jadual sejarah 7 lajur itulah yang kehabisan ruang mendatar,
         bukan kad status yang hanya senarai label.

         Setiap lajur `cols="12"` supaya ia bertindan penuh pada telefon. -->
    <v-row>
      <v-col cols="12" md="5">
        <!-- ── Status sambungan tangkapan ─────────────────────────────────── -->
        <v-card outlined class="mb-4">
          <v-card-title class="py-3 kad__tajuk">
            <v-icon small class="mr-2">mdi-database-import</v-icon>
            <span class="subtitle-1 font-weight-medium">Status Sambungan Tangkapan</span>
          </v-card-title>
          <v-card-text class="pt-5">
            <div v-if="statusLoading" class="text-center py-4">
              <v-progress-circular indeterminate color="#037769"></v-progress-circular>
            </div>

            <template v-else>
              <v-alert
                v-if="tangkapan"
                :type="tangkapan.ok ? 'success' : 'error'"
                border="left"
                elevation="2"
                class="mb-0"
              >
                <div class="d-flex align-center justify-space-between">
                  <strong>DB Tangkapan:</strong>
                  <span>{{ tangkapan.ok ? 'Connected' : 'Tidak Bersambung' }}</span>
                </div>
                <div class="mt-2 text-caption">
                  <div><strong>Host:</strong> {{ tangkapan.host || '-' }}</div>
                  <div><strong>Port:</strong> {{ tangkapan.port || '-' }}</div>
                  <div><strong>Database:</strong> {{ tangkapan.database || '-' }}</div>
                  <div><strong>Pengguna:</strong> {{ tangkapan.user || '-' }}</div>
                  <div v-if="tangkapan.ok">
                    <strong>Jadual di sumber:</strong> {{ formatNumber(tangkapan.tableCount) }}
                  </div>
                  <div v-if="!tangkapan.ok && tangkapan.error" class="mt-1">
                    <strong>Ralat:</strong> {{ tangkapan.error }}
                  </div>
                </div>
              </v-alert>

              <!-- Sambungan ke DB Analisis tidak dipapar di sini: jika ia mati,
                   halaman ini pun tidak akan dimuatkan. Lihat Status Sambungan. -->
              <div class="text-center mt-4">
                <v-btn class="btn-teal" @click="fetchStatus" :loading="statusLoading">
                  Refresh Status
                </v-btn>
              </div>
            </template>
          </v-card-text>
        </v-card>

        <!-- ── Jadual migrasi harian ──────────────────────────────────────── -->
        <v-card outlined class="mb-4">
          <v-card-title class="py-3 kad__tajuk">
            <v-icon small class="mr-2">mdi-calendar-clock</v-icon>
            <span class="subtitle-1 font-weight-medium">Jadual Migrasi Harian</span>
          </v-card-title>
          <v-card-text class="pt-4">
            <div v-if="scheduleLoading" class="text-center py-4">
              <v-progress-circular indeterminate color="#037769"></v-progress-circular>
            </div>
            <template v-else>
              <!-- Hanya set 'Harian' yang boleh dijadualkan. Set Berat ialah
                   ~90% blk_iii (13 juta baris) — ia dicetus secara manual
                   sahaja supaya tiada sesiapa memindahkannya setiap malam
                   tanpa sedar. -->
              <v-alert dense text type="info" class="mb-3 text-caption">
                Jadual ini menarik <strong>set Harian sahaja</strong> (capaian, operasi, lookup).
                Set Berat sentiasa dicetus secara manual.
              </v-alert>

              <v-row dense class="mb-2">
                <v-col cols="12" sm="4">
                  <v-select :items="modeOptions" v-model="scheduleMode" label="Mod" dense outlined hide-details />
                </v-col>

                <v-col cols="12" sm="4" v-if="scheduleMode === 'Daily' || scheduleMode === 'Weekly'">
                  <v-text-field type="time" v-model="scheduleTime" label="Masa" dense outlined hide-details />
                </v-col>

                <v-col cols="12" sm="4" v-if="scheduleMode === 'Advanced'">
                  <v-text-field v-model="scheduleCron" label="Cron Expr" dense outlined hide-details />
                </v-col>

                <v-col cols="12" sm="4" v-if="scheduleMode !== 'Disabled'">
                  <v-combobox :items="timezoneOptions" v-model="scheduleTimezone" label="Zon Masa" dense outlined hide-details />
                </v-col>
              </v-row>

              <v-row dense v-if="scheduleMode === 'Weekly'" class="mb-2">
                <v-col cols="12">
                  <v-select :items="dayOptions" v-model="scheduleDays" multiple chips small-chips label="Hari" dense outlined hide-details />
                </v-col>
              </v-row>

              <v-alert v-if="scheduleError" type="error" dense class="mb-2 text-caption">
                {{ scheduleError }}
              </v-alert>

              <div class="d-flex align-center mt-3">
                <div class="d-flex align-center">
                  <v-chip :color="scheduleActiveState ? 'success' : 'grey'" small text-color="white" class="mr-3">
                    {{ scheduleActiveState ? 'Aktif' : 'Tidak Aktif' }}
                  </v-chip>
                  <span class="text-caption font-weight-medium" v-if="scheduleActiveState && scheduleData && scheduleData.nextRun">
                    Seterusnya: {{ formattedNextRun }}
                  </span>
                </div>
                <v-spacer />
                <v-btn class="btn-teal" small :loading="scheduleSaving" :disabled="!isScheduleValid" @click="saveSchedule">
                  Simpan Jadual
                </v-btn>
              </div>
              <div class="text-caption grey--text mt-2" v-if="scheduleData && scheduleData.schedule && scheduleData.schedule.last_updated_at">
                Kemas kini terakhir oleh {{ scheduleData.schedule.last_updated_by_name || 'sistem' }}, {{ timeAgo(scheduleData.schedule.last_updated_at) }}
              </div>
            </template>
          </v-card-text>
        </v-card>

        <!-- ── Prestasi migrasi ───────────────────────────────────────────── -->
        <v-card outlined>
          <v-card-title class="py-3 kad__tajuk">
            <v-icon small class="mr-2">mdi-speedometer</v-icon>
            <span class="subtitle-1 font-weight-medium">Prestasi Migrasi</span>
          </v-card-title>
          <v-card-text class="pt-4">
            <div v-if="configsLoading" class="text-center py-4">
              <v-progress-circular indeterminate color="#037769"></v-progress-circular>
            </div>
            <template v-else>
              <v-row dense v-for="cfg in configs" :key="cfg.id" class="align-center mb-2">
                <v-col cols="8">
                  <v-text-field
                    v-model="cfg.editValue"
                    :label="cfg.name"
                    :hint="cfg.description"
                    persistent-hint
                    dense
                    outlined
                  ></v-text-field>
                </v-col>
                <v-col cols="4">
                  <v-btn
                    class="btn-teal"
                    small
                    :loading="cfg.saving"
                    @click="saveConfig(cfg)"
                    :disabled="cfg.editValue === cfg.value"
                  >
                    Simpan
                  </v-btn>
                </v-col>
              </v-row>
              <div v-if="configs.length === 0" class="text-caption grey--text">
                Tiada konfigurasi migrasi dijumpai. Tekan "Selaras Default" di halaman Konfigurasi
                untuk menyemainya.
              </div>
            </template>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" md="7">
        <!-- ── Mulakan migrasi ────────────────────────────────────────────── -->
        <v-card outlined class="mb-4">
          <v-card-title class="py-3 kad__tajuk">
            <v-icon small class="mr-2">mdi-database-arrow-right</v-icon>
            <span class="subtitle-1 font-weight-medium">Mulakan Migrasi Tangkapan ke Analisis</span>
          </v-card-title>
          <v-card-text class="pt-5">
            <v-alert v-if="runningBanner" type="warning" border="left" dense class="mb-3">
              {{ runningBanner }}
            </v-alert>

            <v-alert v-if="!linkOk" type="error" border="left" dense class="mb-3">
              Sambungan ke DB Tangkapan tidak tersedia. Migrasi tidak boleh dimulakan.
            </v-alert>

            <v-row dense class="mb-1">
              <v-col cols="12" sm="7">
                <v-select
                  :items="setOptions"
                  v-model="selectedSet"
                  item-text="text"
                  item-value="value"
                  label="Set Jadual"
                  dense
                  outlined
                  hide-details
                  :disabled="migrasiDisabled"
                />
              </v-col>
              <v-col cols="12" sm="5" class="d-flex align-center">
                <span class="text-caption grey--text">
                  {{ selectedSetCount }} jadual dalam set ini
                </span>
                <v-btn icon small class="ml-1" @click="tablesDialog = true" :disabled="!selectedSetCount">
                  <v-icon small>mdi-format-list-bulleted</v-icon>
                </v-btn>
              </v-col>
            </v-row>

            <div class="d-flex align-center mb-3 mt-2">
              <v-btn
                class="btn-teal"
                :disabled="migrasiDisabled || !linkOk"
                :loading="migrasiStarting"
                @click="confirmStart"
              >
                <v-icon left>mdi-database-arrow-right</v-icon>
                Mulakan Migrasi
              </v-btn>
              <v-spacer />
              <v-chip v-if="streamStatus" :color="streamStatusColor" small text-color="white">
                {{ streamStatus }}
              </v-chip>
            </div>

            <div v-if="totalTables > 0" class="mb-2">
              <div class="d-flex justify-space-between text-caption">
                <span>{{ doneTables }} / {{ totalTables }} jadual</span>
                <span>{{ progressPct }}%</span>
              </div>
              <v-progress-linear :value="progressPct" height="8" rounded color="#037769" />
              <!-- Baris kemajuan dalam-jadual. blk_iii sahaja mengambil masa
                   berminit-minit, jadi tanpa ini panel log kelihatan beku. -->
              <div v-if="currentTableProgress" class="text-caption grey--text mt-1">
                {{ currentTableProgress }}
              </div>
            </div>

            <v-card outlined class="mt-2">
              <div class="log-panel" ref="logPanel">
                <div v-for="(line, i) in logLines" :key="i" :class="['log-line', `log-${line.kind}`]">
                  <span class="log-ts">{{ line.ts }}</span>
                  <span class="log-msg">{{ line.msg }}</span>
                </div>
                <div v-if="streamOpen" class="log-line log-info">
                  <v-progress-circular indeterminate size="12" width="2" color="#037769" />
                  <span class="ml-2">Menyambung ke stream...</span>
                </div>
                <div v-if="logLines.length === 0 && !streamOpen" class="log-empty">
                  Belum ada log. Pilih set dan tekan "Mulakan Migrasi" untuk memulakan.
                </div>
              </div>
            </v-card>
          </v-card-text>
        </v-card>

        <!-- ── Sejarah migrasi ────────────────────────────────────────────── -->
        <v-card outlined>
          <v-card-title class="py-3 kad__tajuk">
            <v-icon small class="mr-2">mdi-history</v-icon>
            <span class="subtitle-1 font-weight-medium">Sejarah Migrasi</span>
            <v-spacer />
            <v-btn icon @click="fetchHistory" :loading="historyLoading">
              <v-icon>mdi-refresh</v-icon>
            </v-btn>
          </v-card-title>

          <v-card-text v-if="stuckJob" class="pb-0 pt-4">
            <v-alert type="warning" border="left" dense class="mb-0">
              <v-row align="center" no-gutters>
                <v-col>
                  <strong>⚠ Job #{{ stuckJob.id }}</strong> telah berjalan selama {{ stuckJob.stuckMinutes }} minit.
                </v-col>
                <v-col class="text-right" cols="auto">
                  <v-btn outlined color="black" small @click="confirmUnlock(stuckJob)">Force Unlock</v-btn>
                </v-col>
              </v-row>
            </v-alert>
          </v-card-text>

          <v-data-table
            :headers="historyHeaders"
            :items="history"
            :loading="historyLoading"
            :items-per-page="10"
            class="elevation-0"
            @click:row="openJob"
          >
            <template #item.status="{ item }">
              <v-chip :color="statusColor(item.status)" small text-color="white">
                {{ item.status }}
              </v-chip>
            </template>
            <template #item.set_name="{ item }">
              <v-chip small outlined>{{ item.set_name }}</v-chip>
            </template>
            <template #item.started_at="{ item }">
              {{ formatDate(item.started_at) }}
            </template>
            <template #item.duration_seconds="{ item }">
              {{ formatDuration(item.duration_seconds) }}
            </template>
            <template #item.total_rows="{ item }">
              {{ formatNumber(item.total_rows) }}
            </template>
            <template #item.triggered_by_name="{ item }">
              {{ item.triggered_by_name || '-' }}
              <v-chip v-if="item.source !== 'internal'" x-small :color="sourceColor(item.source)" class="ml-1" text-color="white">
                {{ item.source }}
              </v-chip>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>

    <!-- Senarai jadual dalam set terpilih -->
    <v-dialog v-model="tablesDialog" max-width="600">
      <v-card>
        <v-card-title class="py-3 kad__tajuk">
          <v-icon small class="mr-2">mdi-format-list-bulleted</v-icon>
          <span class="subtitle-1 font-weight-medium">Jadual dalam set "{{ selectedSetLabel }}"</span>
          <v-spacer />
          <v-btn icon @click="tablesDialog = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-card-text class="pt-4">
          <!-- Ini senarai KATALOG, bukan apa yang wujud di tangkapan. Nama yang
               tiada di sumber akan dilangkau semasa larian dan dilaporkan dalam
               log sebagai "tidak dijumpai". -->
          <p class="text-caption grey--text">
            Senarai katalog. Nama yang tiada di DB Tangkapan akan dilangkau dan dilaporkan
            dalam log.
          </p>
          <v-chip v-for="t in selectedSetTables" :key="t" small outlined class="ma-1">{{ t }}</v-chip>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Sahkan mula -->
    <v-dialog v-model="startDialog" max-width="560">
      <v-card>
        <v-card-title class="py-3 kad__tajuk">
          <v-icon small class="mr-2">mdi-database-arrow-right</v-icon>
          <span class="subtitle-1 font-weight-medium">Sahkan Migrasi</span>
        </v-card-title>
        <v-card-text class="pt-4">
          Menarik set <strong>{{ selectedSetLabel }}</strong> ({{ selectedSetCount }} jadual) dari DB
          Tangkapan ke DB Analisis.
          <br /><br />
          Setiap jadual <strong>digantikan sepenuhnya</strong> dengan salinan dari tangkapan.
          Jadual yang dihasilkan oleh sistem ini sendiri (lampiran, modul validasi, konfigurasi)
          tidak pernah disentuh.
          <v-alert v-if="selectedSet !== 'role'" type="warning" dense text class="mt-3 mb-0 text-caption">
            Set ini termasuk <strong>blk_iii</strong> (~13 juta baris). Larian boleh mengambil masa
            beberapa minit dan tidak boleh dibatalkan di pertengahan.
          </v-alert>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="startDialog = false">Batal</v-btn>
          <v-btn class="btn-teal" @click="startMigrasi">Mulakan</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Unlock -->
    <v-dialog v-model="unlockDialog" max-width="500">
      <v-card>
        <v-card-title class="py-3 kad__tajuk">
          <v-icon small class="mr-2">mdi-lock-open-alert</v-icon>
          <span class="subtitle-1 font-weight-medium">Sahkan Force Unlock</span>
        </v-card-title>
        <v-card-text class="pt-4">
          Paksa lepaskan kunci dari Job #{{ jobToUnlock && jobToUnlock.id }} (dimulakan oleh
          {{ (jobToUnlock && jobToUnlock.triggered_by_name) || 'pengguna' }},
          {{ jobToUnlock && jobToUnlock.stuckMinutes }} minit yang lalu)?
          <br /><br />
          Tindakan ini tidak membatalkan proses migrasi yang sedang berjalan, tetapi membenarkan
          larian baharu untuk bermula sekiranya proses lama telah tersangkut.
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="unlockDialog = false">Batal</v-btn>
          <v-btn color="error" :loading="unlocking" @click="doUnlock">Force Unlock</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Butiran job -->
    <v-dialog v-model="jobDialog" max-width="900">
      <v-card v-if="jobDetail">
        <v-card-title class="py-3 kad__tajuk">
          <v-icon small class="mr-2">mdi-file-compare</v-icon>
          <span class="subtitle-1 font-weight-medium">Job #{{ jobDetail.id }}</span>
          <v-spacer />
          <v-btn icon @click="jobDialog = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-card-text class="pt-4">
          <v-row dense>
            <v-col cols="12" sm="6" md="4">
              <div class="text-caption grey--text">Status</div>
              <v-chip :color="statusColor(jobDetail.status)" small text-color="white">
                {{ jobDetail.status }}
              </v-chip>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <div class="text-caption grey--text">Dimulakan oleh</div>
              <div>{{ jobDetail.triggered_by_name || '-' }} ({{ jobDetail.source }})</div>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <div class="text-caption grey--text">Set</div>
              <div>{{ jobDetail.set_name }}</div>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <div class="text-caption grey--text">Tempoh</div>
              <div>{{ formatDuration(jobDetail.duration_seconds) }}</div>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <div class="text-caption grey--text">Mula</div>
              <div>{{ formatDate(jobDetail.started_at) }}</div>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <div class="text-caption grey--text">Tamat</div>
              <div>{{ formatDate(jobDetail.finished_at) }}</div>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <div class="text-caption grey--text">Jadual / Baris</div>
              <div>{{ jobDetail.tables_synced || 0 }} / {{ formatNumber(jobDetail.total_rows) }}</div>
            </v-col>
          </v-row>

          <v-alert v-if="jobDetail.error_message" type="error" dense class="mt-3">
            {{ jobDetail.error_message }}
          </v-alert>

          <div class="text-caption grey--text mt-4 mb-1">Log penuh</div>
          <pre class="log-full">{{ jobDetail.log || '(tiada log)' }}</pre>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import MigrasiDataServices, { MIGRASI_SETS } from '@/services/migrasiData'

const api = new MigrasiDataServices()

export default {
  name: 'MigrasiData',
  data() {
    return {
      // link + catalog
      statusLoading: false,
      tangkapan: null,
      sets: { role: { count: 0, tables: [] }, heavy: { count: 0, tables: [] } },

      // trigger
      setOptions: MIGRASI_SETS,
      selectedSet: 'role',
      startDialog: false,
      tablesDialog: false,
      migrasiStarting: false,
      streamOpen: false,
      streamStatus: '',
      currentJobId: null,
      runningBanner: '',
      totalTables: 0,
      doneTables: 0,
      currentTableProgress: '',
      logLines: [],
      abortCtrl: null,

      // history
      history: [],
      historyLoading: false,
      historyHeaders: [
        { text: 'ID', value: 'id', width: 70 },
        { text: 'Status', value: 'status', width: 110 },
        { text: 'Set', value: 'set_name', width: 90 },
        { text: 'Oleh', value: 'triggered_by_name' },
        { text: 'Mula', value: 'started_at' },
        { text: 'Tempoh', value: 'duration_seconds' },
        { text: 'Jadual', value: 'tables_synced' },
        { text: 'Baris', value: 'total_rows' },
      ],

      // job detail
      jobDialog: false,
      jobDetail: null,

      // perf knobs
      configs: [],
      configsLoading: false,

      // schedule
      scheduleData: null,
      scheduleMode: 'Disabled',
      scheduleTime: '',
      scheduleDays: [],
      scheduleCron: '',
      scheduleTimezone: 'Asia/Kuala_Lumpur',
      scheduleLoading: false,
      scheduleSaving: false,
      scheduleError: null,
      modeOptions: ['Disabled', 'Daily', 'Weekly', 'Advanced'],
      timezoneOptions: ['Asia/Kuala_Lumpur', 'Asia/Singapore', 'Asia/Jakarta'],
      dayOptions: [
        { text: 'Ahad', value: 0 },
        { text: 'Isnin', value: 1 },
        { text: 'Selasa', value: 2 },
        { text: 'Rabu', value: 3 },
        { text: 'Khamis', value: 4 },
        { text: 'Jumaat', value: 5 },
        { text: 'Sabtu', value: 6 },
      ],

      // unlock
      unlockDialog: false,
      jobToUnlock: null,
      unlocking: false,
      unlockedJobIds: [],
    }
  },
  computed: {
    apiUrl() {
      return process.env.VUE_APP_API_URL
    },
    token() {
      return window.localStorage.getItem('access_token') || ''
    },
    linkOk() {
      // Optimistic until the first probe lands, so the button isn't disabled
      // for the split second before /migrasi/status answers.
      return !this.tangkapan || !!this.tangkapan.ok
    },
    selectedSetLabel() {
      const s = this.setOptions.find(o => o.value === this.selectedSet)
      return s ? s.text : this.selectedSet
    },
    selectedSetTables() {
      if (this.selectedSet === 'all') {
        return [...(this.sets.role.tables || []), ...(this.sets.heavy.tables || [])]
      }
      return (this.sets[this.selectedSet] && this.sets[this.selectedSet].tables) || []
    },
    selectedSetCount() {
      return this.selectedSetTables.length
    },
    migrasiDisabled() {
      return this.streamOpen || this.migrasiStarting || !!this.runningBanner
    },
    progressPct() {
      if (!this.totalTables) return 0
      return Math.min(100, Math.round((this.doneTables / this.totalTables) * 100))
    },
    streamStatusColor() {
      if (this.streamStatus === 'Selesai') return 'success'
      if (this.streamStatus === 'Gagal') return 'error'
      return 'primary'
    },
    scheduleActiveState() {
      return this.scheduleData && this.scheduleData.schedulerActive
    },
    isScheduleValid() {
      if (this.scheduleMode === 'Disabled') return true
      if (!this.scheduleTimezone) return false
      if (this.scheduleMode === 'Daily') return !!this.scheduleTime
      if (this.scheduleMode === 'Weekly') return !!this.scheduleTime && this.scheduleDays.length > 0
      if (this.scheduleMode === 'Advanced') return !!this.scheduleCron
      return false
    },
    computedCronExpression() {
      if (this.scheduleMode === 'Daily') {
        const [h, m] = (this.scheduleTime || '00:00').split(':')
        return `${parseInt(m, 10)} ${parseInt(h, 10)} * * *`
      }
      if (this.scheduleMode === 'Weekly') {
        const [h, m] = (this.scheduleTime || '00:00').split(':')
        const dow = [...this.scheduleDays].sort().join(',') || '*'
        return `${parseInt(m, 10)} ${parseInt(h, 10)} * * ${dow}`
      }
      return this.scheduleCron
    },
    formattedNextRun() {
      if (!this.scheduleData || !this.scheduleData.nextRun) return '-'
      const d = new Date(this.scheduleData.nextRun)
      if (isNaN(d.getTime())) return '-'
      const dFormat = d.toLocaleDateString('en-GB', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' })
      const tFormat = d.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' })
      let tz = ''
      try {
        const parts = new Intl.DateTimeFormat('en-GB', { timeZoneName: 'short' }).formatToParts(d)
        const tzPart = parts.find(p => p.type === 'timeZoneName')
        if (tzPart) tz = ' ' + tzPart.value
      } catch (e) {
        // ignore format error
      }
      return `${dFormat}, ${tFormat}${tz}`
    },
    stuckJob() {
      const runningJobs = this.history.filter(
        j => j.status === 'running' && !this.unlockedJobIds.includes(j.id),
      )
      for (const job of runningJobs) {
        const d = new Date(job.started_at)
        if (!isNaN(d.getTime())) {
          const diffMin = (new Date() - d) / 60000
          // 30 minit — sama seperti db-status. Set Berat memang lama, tetapi
          // lebih lama daripada ini bermakna ia patut disemak.
          if (diffMin > 30) return { ...job, stuckMinutes: Math.floor(diffMin) }
        }
      }
      return null
    },
  },
  mounted() {
    this.fetchStatus()
    this.fetchHistory()
    this.fetchSchedule()
    this.fetchConfigs()
  },
  beforeDestroy() {
    // Meninggalkan halaman menutup stream. Job di server TERUS berjalan —
    // ia dipandu oleh runJob, bukan oleh sambungan HTTP ini.
    if (this.abortCtrl) this.abortCtrl.abort()
  },
  methods: {
    // ----- link + catalog -----
    async fetchStatus() {
      this.statusLoading = true
      try {
        const data = await api.status()
        this.tangkapan = data.tangkapan || { ok: false, error: 'Tiada maklum balas' }
        this.sets = data.sets || this.sets
      } catch (err) {
        console.error('Error fetching migrasi status:', err)
        this.tangkapan = {
          ok: false,
          error: (err.response && err.response.data && err.response.data.message) || err.message,
        }
      } finally {
        this.statusLoading = false
      }
    },

    // ----- perf knobs -----
    async fetchConfigs() {
      this.configsLoading = true
      try {
        const rows = await api.getConfigs()
        // Buang baris schedule_* — ia dikongsi type 'migrasi_data' yang sama
        // tetapi sudah ada editornya sendiri (kad Jadual Migrasi Harian di
        // atas). Tanpa penapis ini, cron yang sama boleh diedit di dua tempat.
        this.configs = rows
          .filter(c => !String(c.name).startsWith('schedule_'))
          .map(c => ({ ...c, editValue: c.value, saving: false }))
      } catch (err) {
        console.error('Error fetching migrasi configs:', err)
      } finally {
        this.configsLoading = false
      }
    },
    async saveConfig(cfg) {
      cfg.saving = true
      try {
        const saved = await api.saveConfig(cfg.id, cfg.editValue)
        cfg.value = saved.value
        cfg.editValue = cfg.value
      } catch (err) {
        console.error('Error saving migrasi config:', err)
        alert((err.response && err.response.data && err.response.data.message) || 'Gagal menyimpan konfigurasi')
      } finally {
        cfg.saving = false
      }
    },

    // ----- schedule -----
    async fetchSchedule() {
      this.scheduleLoading = true
      this.scheduleError = null
      try {
        const data = await api.getSchedule()
        this.scheduleData = data
        const sched = data.schedule || {}
        this.scheduleTimezone = sched.timezone || 'Asia/Kuala_Lumpur'
        this.parseCron(sched.cron_expression || '0 3 * * *', sched.enabled)
      } catch (error) {
        console.error('Error fetching migrasi schedule:', error)
        this.scheduleError = 'Gagal memuat turun jadual'
      } finally {
        this.scheduleLoading = false
      }
    },
    parseCron(cronExpr, isEnabled) {
      if (!isEnabled) this.scheduleMode = 'Disabled'
      const parts = (cronExpr || '').trim().split(/\s+/)
      if (parts.length === 5) {
        const [min, hour, dom, mon, dow] = parts
        if (/^\d+$/.test(min) && /^\d+$/.test(hour) && dom === '*' && mon === '*') {
          if (dow === '*') {
            if (isEnabled) this.scheduleMode = 'Daily'
            this.scheduleTime = `${hour.padStart(2, '0')}:${min.padStart(2, '0')}`
            this.scheduleCron = cronExpr
            return
          } else if (/^[0-6](,[0-6])*$/.test(dow)) {
            if (isEnabled) this.scheduleMode = 'Weekly'
            this.scheduleTime = `${hour.padStart(2, '0')}:${min.padStart(2, '0')}`
            this.scheduleDays = dow.split(',').map(Number)
            this.scheduleCron = cronExpr
            return
          }
        }
      }
      if (isEnabled) this.scheduleMode = 'Advanced'
      this.scheduleCron = cronExpr
    },
    async saveSchedule() {
      this.scheduleSaving = true
      this.scheduleError = null
      const payload = {}
      if (this.scheduleMode === 'Disabled') {
        payload.enabled = false
      } else {
        payload.enabled = true
        payload.cronExpression = this.computedCronExpression
        payload.timezone = this.scheduleTimezone
      }
      try {
        const data = await api.saveSchedule(payload)
        this.scheduleData = data
        const sched = data.schedule || {}
        this.scheduleTimezone = sched.timezone || 'Asia/Kuala_Lumpur'
        this.parseCron(sched.cron_expression || '0 3 * * *', sched.enabled)
      } catch (err) {
        console.error('Error saving migrasi schedule', err)
        this.scheduleError = (err.response && err.response.data && err.response.data.message) || 'Gagal menyimpan jadual'
      } finally {
        this.scheduleSaving = false
      }
    },

    // ----- history -----
    async fetchHistory() {
      this.historyLoading = true
      try {
        const items = await api.history()
        this.history = items
        const running = items.find(j => j.status === 'running')
        this.runningBanner = running
          ? `Migrasi sedang berjalan (set ${running.set_name}), dimulakan oleh ${
              running.triggered_by_name || 'pengguna'
            } pada ${this.formatTime(running.started_at)}.`
          : ''
      } catch (err) {
        console.error('Error fetching migrasi history:', err)
      } finally {
        this.historyLoading = false
      }
    },
    async openJob(item) {
      try {
        this.jobDetail = await api.job(item.id)
        this.jobDialog = true
      } catch (err) {
        console.error('Error fetching migrasi job:', err)
      }
    },

    // ----- unlock -----
    confirmUnlock(job) {
      this.jobToUnlock = job
      this.unlockDialog = true
    },
    async doUnlock() {
      this.unlocking = true
      try {
        const data = await api.unlock()
        if (data.released || data.message === 'No running job to unlock') {
          this.unlockDialog = false
          if (this.jobToUnlock) this.unlockedJobIds.push(this.jobToUnlock.id)
          this.fetchHistory()
        }
      } catch (err) {
        console.error('Failed to unlock', err)
      } finally {
        this.unlocking = false
      }
    },

    // ----- trigger + SSE -----
    confirmStart() {
      this.startDialog = true
    },
    async startMigrasi() {
      this.startDialog = false
      this.resetState()
      this.migrasiStarting = true
      this.appendLog('info', `Menghantar permintaan migrasi (set ${this.selectedSet})...`)

      // fetch, bukan axios: kita perlukan badan respons sebagai stream. axios
      // dalam pelayar hanya memberi teks penuh selepas respons tamat, jadi log
      // langsung mustahil melaluinya.
      this.abortCtrl = new AbortController()
      let response
      try {
        response = await fetch(
          `${this.apiUrl}/migrasi/trigger?set=${encodeURIComponent(this.selectedSet)}`,
          {
            method: 'GET',
            headers: {
              Authorization: `Bearer ${this.token}`,
              Accept: 'text/event-stream',
            },
            signal: this.abortCtrl.signal,
          },
        )
      } catch (err) {
        this.migrasiStarting = false
        this.appendLog('error', `Gagal menyambung: ${err.message}`)
        return
      }

      if (response.status === 409) {
        let body = {}
        try {
          body = await response.json()
        } catch (e) { /* ignore */ }
        const job = body.job || {}
        const who = job.triggeredBy || 'pengguna lain'
        const when = job.startedAt ? this.formatTime(job.startedAt) : ''
        this.runningBanner = `Migrasi sudah berjalan, dimulakan oleh ${who}${
          when ? ' pada ' + when : ''
        }. Sila cuba lagi selepas selesai.`
        this.appendLog('warn', this.runningBanner)
        this.migrasiStarting = false
        this.fetchHistory()
        return
      }

      if (!response.ok) {
        this.migrasiStarting = false
        let msg = `HTTP ${response.status}`
        if (response.status === 403) msg = 'Akses ditolak (perlu peranan ADMIN).'
        if (response.status === 503) msg = 'DB Tangkapan belum dikonfigurasi pada server ini.'
        if (response.status === 400) {
          try {
            const b = await response.json()
            msg = b.message || msg
          } catch (e) { /* ignore */ }
        }
        this.appendLog('error', msg)
        return
      }

      this.migrasiStarting = false
      this.streamOpen = true
      this.streamStatus = 'Berjalan'

      try {
        await this.consumeSseStream(response)
      } catch (err) {
        if (err.name !== 'AbortError') {
          this.appendLog('error', `Stream ralat: ${err.message}`)
          this.streamStatus = 'Gagal'
        }
      } finally {
        this.streamOpen = false
        this.abortCtrl = null
        this.fetchHistory()
      }
    },

    async consumeSseStream(response) {
      const reader = response.body.getReader()
      const decoder = new TextDecoder('utf-8')
      let buf = ''
      let streaming = true
      while (streaming) {
        const { done, value } = await reader.read()
        if (done) {
          streaming = false
          break
        }
        buf += decoder.decode(value, { stream: true })
        let sepIdx = buf.indexOf('\n\n')
        while (sepIdx !== -1) {
          const raw = buf.slice(0, sepIdx)
          buf = buf.slice(sepIdx + 2)
          this.handleSseBlock(raw)
          sepIdx = buf.indexOf('\n\n')
        }
      }
    },

    handleSseBlock(raw) {
      const lines = raw.split('\n')
      let event = 'message'
      let data = ''
      for (const line of lines) {
        if (!line || line.startsWith(':')) continue // heartbeat / comment
        if (line.startsWith('event:')) {
          event = line.slice(6).trim()
        } else if (line.startsWith('data:')) {
          data += (data ? '\n' : '') + line.slice(5).trim()
        }
      }
      if (!data && event === 'message') return
      let payload = null
      if (data) {
        try {
          payload = JSON.parse(data)
        } catch (e) {
          payload = { raw: data }
        }
      }
      this.handleSseEvent(event, payload || {})
    },

    handleSseEvent(event, d) {
      switch (event) {
        case 'job':
          this.currentJobId = d.jobId
          this.appendLog('info', `Job #${d.jobId} dimulakan oleh ${d.triggeredBy || 'anda'}.`)
          break
        case 'start':
          this.totalTables = (d.tables || []).length
          this.doneTables = 0
          this.appendLog(
            'info',
            `Mula migrasi ${d.database} @ ${d.source} → analisis, set '${d.set}' (${this.totalTables} jadual).`,
          )
          break
        case 'plan':
          this.currentTableProgress = `[${d.table}] menarik ~${this.formatNumber(d.rows)} baris...`
          break
        case 'progress':
          // Tidak masuk panel log: pada blk_iii ia beratus baris yang tidak
          // memberitahu apa-apa yang baris akhir jadual itu tidak beritahu.
          this.currentTableProgress = `[${d.table}] ${this.formatNumber(d.rows)} / ~${this.formatNumber(
            d.totalRows,
          )} baris`
          break
        case 'table':
          this.doneTables += 1
          this.currentTableProgress = ''
          this.appendLog('ok', `[${d.table}] ${this.formatNumber(d.rows)} baris dalam ${d.durationSec}s`)
          break
        case 'skip':
          this.appendLog('warn', `[${d.table}] dilangkau — ${d.reason || 'tidak diketahui'}`)
          break
        case 'done':
          this.streamStatus = 'Selesai'
          this.currentTableProgress = ''
          this.appendLog(
            'done',
            `Selesai: ${d.tablesSynced} jadual, ${this.formatNumber(d.totalRows)} baris dalam ${d.durationSec}s.`,
          )
          break
        case 'error':
          this.streamStatus = 'Gagal'
          this.currentTableProgress = ''
          this.appendLog('error', `Ralat${d.table ? ` [${d.table}]` : ''}: ${d.message || 'tidak diketahui'}`)
          break
        default:
          if (d && Object.keys(d).length) {
            this.appendLog('info', `[${event}] ${JSON.stringify(d)}`)
          }
      }
    },

    resetState() {
      this.logLines = []
      this.totalTables = 0
      this.doneTables = 0
      this.currentTableProgress = ''
      this.streamStatus = ''
      this.currentJobId = null
    },

    appendLog(kind, msg) {
      this.logLines.push({ kind, msg, ts: this.nowHms() })
      this.$nextTick(() => {
        const el = this.$refs.logPanel
        if (el) el.scrollTop = el.scrollHeight
      })
    },

    // ----- formatting -----
    timeAgo(dateStr) {
      if (!dateStr) return ''
      const d = new Date(dateStr)
      if (isNaN(d.getTime())) return ''
      const diffSecs = Math.floor((new Date() - d) / 1000)
      if (diffSecs < 60) return `${diffSecs} saat yang lalu`
      if (diffSecs < 3600) return `${Math.floor(diffSecs / 60)} minit yang lalu`
      if (diffSecs < 86400) return `${Math.floor(diffSecs / 3600)} jam yang lalu`
      return `${Math.floor(diffSecs / 86400)} hari yang lalu`
    },
    nowHms() {
      const d = new Date()
      return [d.getHours(), d.getMinutes(), d.getSeconds()]
        .map(n => String(n).padStart(2, '0'))
        .join(':')
    },
    formatDate(v) {
      if (!v) return '-'
      const d = new Date(v)
      if (isNaN(d.getTime())) return v
      const pad = n => String(n).padStart(2, '0')
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(
        d.getHours(),
      )}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`
    },
    formatTime(v) {
      if (!v) return '-'
      const d = new Date(v)
      if (isNaN(d.getTime())) return v
      const pad = n => String(n).padStart(2, '0')
      return `${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`
    },
    formatDuration(sec) {
      if (sec == null) return '-'
      const s = Number(sec)
      if (!isFinite(s)) return '-'
      if (s < 60) return `${s.toFixed(1)}s`
      const m = Math.floor(s / 60)
      const r = Math.round(s - m * 60)
      return `${m}m ${r}s`
    },
    formatNumber(n) {
      if (n == null) return '-'
      return Number(n).toLocaleString('en-US')
    },
    statusColor(status) {
      if (status === 'completed') return 'success'
      if (status === 'running') return 'primary'
      if (status === 'failed') return 'error'
      return 'grey'
    },
    sourceColor(source) {
      if (source === 'cron') return 'info'
      if (source === 'external') return 'deep-purple'
      return 'grey'
    },
  },
}
</script>

<style scoped>
/* Gaya diambil sebulat-bulatnya dari db-status/ConnectionStatus.vue supaya
   kedua-dua halaman Tetapan Sistem kelihatan sebagai satu sistem: jalur kepala
   kad putih dengan ikon teal, butang teal, panel log gelap. */
.kad__tajuk {
  border-bottom: 1px solid #dbeeeb;
}
.kad__tajuk .v-icon {
  color: #037769;
}
/* Menggantikan `color="primary"` — primary Vuetify ialah biru. Warna disebut
   secara literal dan bukan var(--teal-700) kerana pembolehubah itu ditakrif
   pada `.Menu` dalam MenuHeader, bukan pada :root. */
.btn-teal.v-btn {
  background: #037769 !important;
  color: #ffffff !important;
  letter-spacing: normal;
}
.btn-teal.v-btn:hover {
  background: #026254 !important;
}
/* Butang lumpuh mesti kekal kelihatan lumpuh. */
.btn-teal.v-btn--disabled {
  background: #cfd8dc !important;
  color: rgba(0, 0, 0, 0.38) !important;
}
.log-panel {
  background: #0e1117;
  color: #d4d4d4;
  font-family: 'Consolas', 'Monaco', monospace;
  font-size: var(--fs-xs);
  line-height: 1.5;
  padding: 10px 12px;
  height: 280px;
  overflow-y: auto;
  border-radius: 4px;
}
.log-line {
  white-space: pre-wrap;
  word-break: break-word;
}
.log-ts {
  color: #6b7280;
  margin-right: 8px;
}
.log-info .log-msg { color: #d4d4d4; }
.log-ok .log-msg { color: #22c55e; }
.log-warn .log-msg { color: #f59e0b; }
.log-error .log-msg { color: #ef4444; }
.log-done .log-msg { color: #38bdf8; font-weight: 600; }
.log-empty {
  color: #6b7280;
  text-align: center;
  padding: 24px 0;
}
.log-full {
  background: #0e1117;
  color: #d4d4d4;
  font-family: 'Consolas', 'Monaco', monospace;
  font-size: var(--fs-xs);
  padding: 12px;
  max-height: 400px;
  overflow: auto;
  border-radius: 4px;
  white-space: pre-wrap;
  word-break: break-word;
}
</style>
